import { render, staticRenderFns } from "./addTablesAndWaiters.vue?vue&type=template&id=62ad3431&scoped=true&"
import script from "./addTablesAndWaiters.vue?vue&type=script&lang=js&"
export * from "./addTablesAndWaiters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad3431",
  null
  
)

export default component.exports